
import { UseFormReturn } from "react-hook-form";
import { TerraceFormValues } from '@/components/terrace-submission/types';

export const useFormValidation = (form: UseFormReturn<TerraceFormValues>) => {
  // Validate coordinates are reasonable
  const validateCoordinates = (lat: number, lng: number): boolean => {
    return !isNaN(lat) && !isNaN(lng) && 
           lat !== 0 && lng !== 0 &&
           Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
  };

  // Validate opening hours format
  const validateTimeFormat = (time: string): boolean => {
    if (!time) return true; // Empty is valid
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
    return timeRegex.test(time);
  };

  // Validate URL format
  const validateUrl = (url: string): boolean => {
    if (!url) return true; // Empty is valid
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  // Validate phone format (basic)
  const validatePhone = (phone: string): boolean => {
    if (!phone) return true; // Empty is valid
    const phoneRegex = /^[\+]?[0-9\s\-\(\)]{7,15}$/;
    return phoneRegex.test(phone);
  };

  // Check if form has any validation errors
  const hasValidationErrors = (): boolean => {
    return Object.keys(form.formState.errors).length > 0;
  };

  // Get all validation error messages
  const getValidationErrors = (): string[] => {
    const errors: string[] = [];
    Object.entries(form.formState.errors).forEach(([field, error]) => {
      if (error?.message) {
        errors.push(`${field}: ${error.message}`);
      }
    });
    return errors;
  };

  // Validate required fields are filled
  const validateRequiredFields = (): boolean => {
    const values = form.getValues();
    return !!(values.name && values.type && values.address);
  };

  return {
    validateCoordinates,
    validateTimeFormat,
    validateUrl,
    validatePhone,
    hasValidationErrors,
    getValidationErrors,
    validateRequiredFields
  };
};
